<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
      v-loading="loading"
      :element-loading-text="loadingText"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">任务详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <!-- prop="ResourceName" -->
      <zj-layout-main>
        <el-form
          ref="form"
          :model="data"
          :rules="rules"
          label-width="16rem"
          style="width: 80%"
        >
          <el-row>

            <el-col :span="12">
              <el-form-item label="接收人" prop="receiveUserId">
                <el-select
                  v-model="data.receiveUserId"
                  placeholder="请选择"
                  style="width: 100%"
                  :disabled="!IsEdit"
                >
                  <el-option
                    v-for="item in userList"
                    :key="item.userId"
                    :label="item.name"
                    :value="item.userId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
             <el-col :span="12">
              <el-form-item label="任务标题" prop="title">
                <el-input v-model="data.title" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="任务内容" prop="taskContent">
                <el-input
                  v-model="data.taskContent"
                  :disabled="!IsEdit"
                  type="textarea"
                  :autosize="{ minRows: 4 }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="任务地址" prop="address">
                <el-input
                  v-model="data.address"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="补充任务地址" prop="addressExtra">
                <el-input
                  v-model="data.addressExtra"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
           <el-row>
            <el-col :span="12">
              <el-form-item label="任务下发时间" prop="updateTime">
                <el-input v-model="data.updateTime" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
             <el-col :span="12">
              <el-form-item label="任务处理截止时间" prop="endTime">
                <el-input v-model="data.endTime" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
           <el-row><el-form-item label="处理结果："  class="uploadfile" ></el-form-item></el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item
                label="问题解决的图片"
                class="uploadfile"
                prop="productimages"
              >
                <el-upload
                  list-type="picture-card"
                  action="#"
                  :before-upload="beforeUploadImg"
                  :on-remove="onRemoveFile"
                  :http-request="uploadFile"
                  :file-list="fileList"
                  :disabled="!IsEdit"
                >
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
           <el-row>
            <el-col :span="24">
              <!-- <el-form-item
                label="问题解决的语音"
                class="uploadfile"
                prop="productimages"
              >
                <el-upload
                  list-type="picture-card"
                  action="#"
                  :before-upload="beforeUploadImg"
                  :on-remove="onRemoveFile"
                  :http-request="uploadFile"
                  :file-list="audioList"
                  :disabled="!IsEdit"
                >
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item> -->
               <el-form-item label="问题解决的语音" prop="audioList">
                <div v-for="(ele, index) in audioList" :key="index">
                  <audio v-bind:src="ele.url" controls="controls"></audio>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
           <el-row>
            <el-col :span="24">
              <el-form-item
                label="问题解决的视频"
                class="uploadfile"
                prop="productimages"
              >
                <!-- <el-upload
                  list-type="picture-card"
                  action="#"
                  :before-upload="beforeUploadImg"
                  :on-remove="onRemoveFile"
                  :http-request="uploadFile"
                  :file-list="videoList"
                  :disabled="!IsEdit"
                >
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload> -->
                <div v-for="(ele, index) in videoList" :key="index">
                  <video
                    controls
                    style="width: 300px; height: 150px; margin-bottom: 10px"
                  >
                    <source v-bind:src="ele.url" type="video/mp4" />
                  </video>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="处理结果" prop="name">
                <el-input v-model="data.name" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
            <el-row>
            <el-col :span="24">
              <el-form-item label="处理结果说明" prop="finishIntro">
                <el-input
                  v-model="data.finishIntro"
                  :disabled="!IsEdit"
                  type="textarea"
                  :autosize="{ minRows: 4 }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
            <el-row>
            <el-col :span="24">
              <el-form-item label="任务处理时间" prop="finishTime">
                <el-input
                  v-model="data.finishTime"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </zj-layout-main>
      <el-form-item class="right" style="width: 134rem">
        <el-button @click="onBack()">返回</el-button>
        <el-button
          type="primary"
          @click="saveForm()"
          :disabled="!IsEdit"
          v-if="IsEdit"
          >保存</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import fileApi from "@/request/fileApi.js";
import ZJApp from "../../../../../app";
// import ComplaintApi from "../../../apis/src/ComplaintApi";
// import utils from "../../../../../../utils";
import { urbanUserList, taskDetails } from "@/api/src/urbanServerApi";
export default {
  name: "TaskCenterDetails",
  controller: "UI",
  action: "TaskCenterDetails",
  data() {
    return {
      data: {},
      upLoadUrl: "",
      // 上传图片数组
      fileImgList: [],
      newImgFileList: [],
      imgArr: [],
      fileList: [
        // {url:"http://localhost:8080/plugin/TaskCenter/ui/TaskCenterDetails?id=56&type=query"}
      ],
      audioList: [
        //  {url:"http://localhost:8080/plugin/TaskCenter/ui/TaskCenterDetails?id=56&type=query"}
      ],
      videoList: [],


      loading: false,
      loadingText: "加载中...",
      EqRegionArr: [],
      IsEdit: false,

      // rules: {
      //   address: [{ required: true, message: "请输入事发地", trigger: "blur" }],
      //   content: [
      //     { required: true, message: "请输入投诉内容", trigger: "blur" },
      //   ],
      //   name: [{ required: true, message: "请输入联系人", trigger: "blur" }],
      //   phone: [
      //     { required: true, validator: this.validphone, trigger: "blur" },
      //   ],

      //   platform: [
      //     { required: true, message: "请选择投诉来源", trigger: "change" },
      //   ],
      // },
      userList:[],
      uuid:
        this.$route.query.type == "edit"
          ? this.$route.query.InfoId
          : ZJApp.ZJUtils.uuid(),
    };
  },
  created: function () {
    this.searchUserList()
    if (this.$route.query.id) {
      this.search();
    }
    if (this.$route.query.type == "query") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
  },
  mounted: function () {},
  watch: {
    $route: function () {
      if (this.$route.query.id) {
        this.search();
      }
    },
  },

  methods: {
    searchUserList(){
      let that = this;
      urbanUserList().then(res=>{
        if(res.code==200){
          that.userList=res.data||[]
        }
      })
    },
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    // validphone: function (rule, value, callback) {
    //   console.log("validphone");
    //   // if (!value) {
    //   //   callback(new Error("请输入联系方式"));
    //   // } else if (!utils.isRightMobileNum(value)) {
    //   //   callback(new Error("请输入正确的手机号"));
    //   // } else {
    //   //   callback();
    //   // }
    // },
    search() {
      let id = this.$route.query.id;
      if (id) {
        taskDetails({id})
          .then((res) => {
            if(res.code==200||res.code==0){
                let data=res.rows||res.data;
                console.log("details========")
                console.log(data)
                // if(data.uploadResource){
                //   let arr = data.uploadResource.split(",")
                //   this.fileList = arr.map((item) => ({
                //     url: item,
                //   }));
                // }
                // if(data.processVideos){
                //   let arr = data.processVideos.split(",")
                //   this.videoList = arr.map((item) => ({
                //     url: item,
                //   }));
                // }
                // if(data.processAudios){
                //   let arr = data.processAudios.split(",")
                //   this.audioList = arr.map((item) => ({
                //     url: item,
                //   }));
                // }
                this.data = data;
            }
            // r = r.data;
            // this.data = r;
            // this.fileList =
            //   this.data.productimages == null || this.data.productimages == ""
            //     ? []
            //     : this.data.productimages.split(",");

            // this.fileList = this.fileList.map((item) => ({
            //   url: item,
            // }));
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    // 上传图片前
    beforeUploadImg(file) {
      let reg = ["jpg", "png", "jpeg", "pic", "tif", "bmp", "gif"];
      return this.beforeUpload(file, "img", reg);
    },
    uploadFileImg(params) {
      this.uploadFile(params, (data) => {
        this.fileImgList.push(data);
        this.newImgFileList.push(data);
        this.imgArr.push(data.src);

        this.$message({
          type: "success",
          message: "上传文件成功",
        });
      });
    },
    // 上传文件前
    beforeUpload(file, type, reg) {
      let FileExt = file.name.replace(/.+\./, "");

      if (reg.indexOf(FileExt.toLowerCase()) === -1) {
        this.$message({
          type: "error",
          message:
            "上传文件只能是 " + reg.lenght > 0
              ? reg.split(",")
              : JSON.stringify(reg) + "格式",
        });
        return false;
      }
    },
    // 上传文件
    uploadFile(params) {
      const _file = params.file;

      fileApi
        .uploadFile(_file)
        .then((r) => {
          if (r.code == 0 && r.data) {
            let data = r.data;
            this.fileImgList.push(data);
            this.newImgFileList.push(data);
            this.imgArr.push(data.src);
          }

          this.$message({
            type: "success",
            message: r.msg == "成功" ? "上传文件成功" : "上传失败，请重新上传",
          });
        })
        .catch((e) => {
          this.$message({
            type: "error",
            message: "上传失败，请重新上传",
          });
          console.log(e);
          //this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    // 删除文件
    onRemoveFile(file) {
      let fileID = "";
      let fileIndex = "";
      this.fileImgList.forEach((item, index) => {
        if (file.name === item.filename) {
          fileID = item.fileid;
          fileIndex = index;
        }
      });
      this.fileImgList.splice(fileIndex, 1);
      this.imgArr.splice(fileIndex, 1);
      if (fileID) {
        fileApi
          .deleteFile(fileID)
          .then((r) => {
            if (r) {
              this.$message({
                type: "success",
                message: "删除成功",
              });
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },

    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //保存
    saveForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.saveData();
        } else {
          return false;
        }
      });
    },
    saveData() {
      this.loading = true;
      this.loadingText = "保存中...";
      if (this.fileImgList.length > 0) {
        this.data.productimages = this.imgArr.join(",");
      }
      if (this.$route.query.type == "edit") {
        ComplaintApi.SuggestUpdate(this.data)
          .then((r) => {
            r = r.msg;
            this.$message({
              type: "success",
              message: r == "成功" ? "保存成功！" : "保存失败！",
            });
            this.loading = false;
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            //this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      } else {
        ComplaintApi.SuggestAdd(this.data)
          .then((r) => {
            r = r.msg;
            this.$message({
              type: "success",
              message: r == "成功" ? "保存成功！" : "保存失败！",
            });
            this.loading = false;
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            //this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    beforeupload: function () {
      this.uploadData.assocID = this.uuid;
      this.loading = true;
      this.loadingText = "上传中... 0%";
    },
    uploadsuccess: function () {
      this.loading = false;
    },
    uploadError(err) {
      console.error("上传失败: ", err);
      this.errmsg("上传失败: " + err);
      this.loading = false;
    },
    uploadProgress(e) {
      this.loadingText = "上传中... " + parseInt(e.percent) + "%";
    },
    handlePreview(file) {
      console.log(file);
      document.location.href = file.url;
    },
  },
};
</script>
